import { findClientByDNI } from "clients/api"

const findClientByTask = dni => {
    return findClientByDNI(dni).then(data => data.data())
}

export default findClientByTask